// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  structId: __t.u64().primaryKey().name("struct_id"),
  owner: __t.identity(),
  kind: __t.string(),
  systemId: __t.string().name("system_id"),
  x: __t.f64(),
  y: __t.f64(),
  z: __t.f64(),
  deedJson: __t.string().name("deed_json"),
  deployedAt: __t.timestamp().name("deployed_at"),
});
